import { useCrowdfundingProvider } from '#Context/index.js';
import { PeerParticipant, useShowCampaignSettings } from '@givebacks/api/store';
import { ButtonMantine, Card, Group, Text } from 'ui';

import { ActivityLogTable } from './table/ActivityLogTable';

const ActivityLogCard = ({
  participant,
  onClick,
  unitsOfActivity,
}: {
  participant: PeerParticipant;
  onClick?: () => void;
  unitsOfActivity?: string;
}) => {
  const { campaignId, causeId } = useCrowdfundingProvider();
  const { data: settings } = useShowCampaignSettings({ causeId, campaignId });

  return (
    <Card p={0} radius="sm" bd="1px solid gray.1">
      <Group justify="space-between" py="lg" px="md">
        <Text fw={600}>Activity Log</Text>
        {!settings?.isCampaignFinished && (
          <ButtonMantine size="sm" onClick={onClick}>
            Log New Activity
          </ButtonMantine>
        )}
      </Group>
      <ActivityLogTable participant={participant} units={unitsOfActivity} />
    </Card>
  );
};

export { ActivityLogCard };
